export function getArticleLinkNodeId(link) {
    if ('__typename' in link && 'sitemapNode' in link) {
        return link.sitemapNode.id;
    }
    if ('id' in link) {
        return link.id;
    }
    return null;
}
//# sourceMappingURL=getArticleLinkNodeId.js.map